module.exports = __webpack_public_path__ + "static/media/mini.0ab84906.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200S厢式车/mini.png
// module id = 717
// module chunks = 0